import { EncumbranceDetailsPageContextType } from '../types/EncumbranceDetailsPageContextType';

export const encumbranceDetailPageInitValue: EncumbranceDetailsPageContextType =
  {
    data: {
      type: '',
      from: 0,
      to: 0,
      date: '',
      endDate: '',
      scriptureData: {
        notaryName: '',
        protocolNr: '',
        notaryCity: '',
      },
      document: null,
      coOwners: [],
      coOwnersTotal: 0,
      coOwnersPercentage: 0,
      page: 0,
      rowsPerPage: 0,
      isAdmin: false,
      isReadOnly: false,
      isLoading: false,
    },
    actions: {
      handleChangePage: () => {},
      handleChangeRowsPerPage: () => {},
      handleEditEncumbrance: () => {},
      handleRemoveEncumbrance: () => {},
      handleAddCoOwner: () => {},
      handleEditCoOwner: () => {},
      handleRemoveCoOwner: () => {},
    },
  };
